import { render, staticRenderFns } from "./logModal.vue?vue&type=template&id=22062934&scoped=true&"
import script from "./logModal.vue?vue&type=script&lang=js&"
export * from "./logModal.vue?vue&type=script&lang=js&"
import style0 from "./logModal.vue?vue&type=style&index=0&id=22062934&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22062934",
  null
  
)

export default component.exports